import type { RuleArea } from "@unbox/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { RULE_AREA_DETAILS, RULE_AREA_ORDER } from "./rule-areas";

type NewRuleDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPick: (area: RuleArea) => void;
};

export const NewRuleDialog = ({ open, onOpenChange, onPick }: NewRuleDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>New rule</DialogTitle>
        <DialogDescription>What should this rule do?</DialogDescription>
      </DialogHeader>
      <div className="flex flex-col gap-2">
        {RULE_AREA_ORDER.map((area) => {
          const { label, description, icon: Icon } = RULE_AREA_DETAILS[area];
          return (
            <button
              key={area}
              type="button"
              className="flex items-start gap-3 rounded-lg border border-secondary p-4 text-left transition-colors hover:bg-primary_hover"
              onClick={() => onPick(area)}
            >
              <Icon className="mt-0.5 size-5 shrink-0 text-quaternary" strokeWidth={1.8} />
              <span className="flex flex-col gap-0.5">
                <span className="text-sm font-medium text-primary">{label}</span>
                <span className="text-sm text-tertiary">{description}</span>
              </span>
            </button>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
